const services = [
  {
    num: '01', tag: 'Growth',
    title: 'Social Media Management',
    desc: 'Strategic content creation, scheduling, and community management that grows your audience.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" width="28" height="28">
        <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>
      </svg>
    ),
  },
  {
    num: '02', tag: 'Audio',
    title: 'Voiceovers',
    desc: 'Professional, high-quality recordings for ads, explainers, podcasts, and corporate content.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" width="28" height="28">
        <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"/>
        <path d="M19 10v2a7 7 0 0 1-14 0v-2"/>
        <line x1="12" y1="19" x2="12" y2="23"/>
        <line x1="8" y1="23" x2="16" y2="23"/>
      </svg>
    ),
  },
  {
    num: '03', tag: 'Visual',
    title: 'Photography & Videography',
    desc: 'Cinematic visuals that capture your brand story — from product shoots to corporate films.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" width="28" height="28">
        <path d="M23 7l-7 5 7 5V7z"/>
        <rect x="1" y="5" width="15" height="14" rx="2"/>
      </svg>
    ),
  },
  {
    num: '04', tag: 'Creative',
    title: 'Video Editing & Design',
    desc: 'Polished edits, motion graphics, and stunning visual assets that stop the scroll.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" width="28" height="28">
        <polygon points="12 2 2 7 12 12 22 7 12 2"/>
        <polyline points="2 17 12 22 22 17"/>
        <polyline points="2 12 12 17 22 12"/>
      </svg>
    ),
  },
  {
    num: '05', tag: 'Strategy',
    title: 'Promotion Strategy',
    desc: 'Custom-built marketing campaigns across channels designed to reach the right people.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" width="28" height="28">
        <circle cx="12" cy="12" r="10"/>
        <circle cx="12" cy="12" r="3"/>
        <line x1="12" y1="2" x2="12" y2="5"/>
        <line x1="12" y1="19" x2="12" y2="22"/>
        <line x1="2" y1="12" x2="5" y2="12"/>
        <line x1="19" y1="12" x2="22" y2="12"/>
      </svg>
    ),
  },
  {
    num: '06', tag: 'Retention',
    title: 'Email Marketing',
    desc: 'Targeted email campaigns that nurture leads, retain customers, and drive measurable conversions.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" width="28" height="28">
        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
        <polyline points="22,6 12,13 2,6"/>
      </svg>
    ),
  },
  {
    num: '07', tag: 'SEO',
    title: 'Search Engine Optimisation',
    desc: 'On-page, off-page, and technical SEO that pushes your brand to the top of search results.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" width="28" height="28">
        <circle cx="11" cy="11" r="8"/>
        <line x1="21" y1="21" x2="16.65" y2="16.65"/>
      </svg>
    ),
  },
  {
    num: '08', tag: 'Tech',
    title: 'Web Development',
    desc: 'Fast, responsive, beautifully designed websites and web apps built to convert visitors.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" width="28" height="28">
        <polyline points="16 18 22 12 16 6"/>
        <polyline points="8 6 2 12 8 18"/>
      </svg>
    ),
  },
];

const Services = () => (
  <section className="section services" id="services">
    <div className="container">
      <div className="section-header reveal">
        <span className="section-tag">What We Do</span>
        <h2>Services Built to <span className="red">Grow Your Brand</span></h2>
        <p>Everything your brand needs under one roof — creative, strategic, and results-focused.</p>
      </div>
      <div className="services-cards">
        {services.map((s, i) => (
          <div className="svc-card reveal" key={s.num} data-delay={i * 70}>
            <div className="svc-card-top">
              <span className="svc-num">{s.num}</span>
              <span className="svc-pill">{s.tag}</span>
            </div>
            <div className="svc-icon">{s.icon}</div>
            <h3 className="svc-title">{s.title}</h3>
            <p className="svc-desc">{s.desc}</p>
            <div className="svc-arrow">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="16" height="16">
                <path d="M7 17L17 7M17 7H7M17 7v10"/>
              </svg>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Services;
